<template>
  <page>
    <template #header-bar>
      <page-header-bar>Admin</page-header-bar>
    </template>
    <template #content>
      <page-tabs
        v-model="selectedTabIndex"
        :tabs="tabs"
        use-tab-routes
      >
        <page-tab-panel class="pa-6">
          <review-activity-table cypress-id="admin-review-activity" />
        </page-tab-panel>
        <page-tab-panel class="pa-6">
          <user-activity-table cypress-id="admin-user-activity" />
        </page-tab-panel>
        <page-tab-panel class="pa-6">
          <admin-user-management-content />
        </page-tab-panel>
      </page-tabs>
    </template>
  </page>
</template>

<script>
import Page from '@/components/Common/Page';
import PageHeaderBar from '@/components/Common/PageHeaderBar';
import PageTabs from '@/components/Common/PageTabs';
import PageTabPanel from '@/components/Common/PageTabPanel';
import ReviewActivityTable from '@/components/AdminPage/ReviewActivityTable';
import UserActivityTable from '@/components/AdminPage/UserActivityTable';
import AdminUserManagementContent from '@/components/AdminUserManagementPage/AdminUserManagementContent';

export default {
  name: 'AdminPage',
  components: {
    Page,
    PageHeaderBar,
    PageTabs,
    PageTabPanel,
    ReviewActivityTable,
    UserActivityTable,
    AdminUserManagementContent,
  },
  data: () => ({
    tabs: ['Review Activity', 'User Activity', 'Users'],
    selectedTabIndex: 0,
  }),
};
</script>
